import React, { useState } from "react";
import { StartTrialModal } from ".";
import {
    Collapse,
    UncontrolledCollapse,
    Button,
    CardBody,
    Card,
} from "reactstrap";
import Lazyload from "react-lazy-load";
const PricingPage = (props) => {
    return (
        <>
            <section className="pricing-hero bannerAreaN whitebackground BannerDeatils hero-bg">
                <div className="detailsPageSection">
                    <img
                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1683184844/VantageFit/2023/background.png"
                        alt="corporate wellness"
                        className="img-responsive"
                        width="1915"
                        height="700"
                    />
                </div>
                <div className="BannerContent singleHeading">
                    <div className="headingBannerM container customCampaignContainer text-left ">
                        <div className="row">
                            <div className="text-center col-lg-12 col-xs-12 col-md-12 col-sm-12 mt-5">
                                <h1 className="font-weight-bold hero-heading">
                                    Choose a{" "}
                                    <span className="text-red">plan</span> that
                                    works for you
                                </h1>
                                <p className="hero-para font-weight-semibold">
                                    We deliver the best services to our
                                    customers with a cost-effective pricing
                                    plan. We offer flexible pricing to our
                                    clients irrespective of their company size
                                    and requirements
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="pricing-table">
                <div className="container pricing_container">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="card mb-5 mb-lg-0 rounded-lg shadow">
                                <div className="card-header basic-header">
                                    <h2 className="card-title">Basic</h2>
                                    <h3
                                        className=""
                                        style={{ fontSize: "30px" }}
                                    >
                                        Free
                                    </h3>
                                    <p>For upto 10 users </p>
                                </div>
                                <div className="card-body bg-light rounded-bottom">
                                    <p>Includes:</p>
                                    <ul className="pricing-ticks mainbullets">
                                        <li className="mb-5">
                                            Streak, Race, and Themed Challenges
                                        </li>
                                        <li className="mb-5">
                                            Journey Challenges
                                        </li>
                                        <li className="mb-5">
                                            Create custom challenges with a
                                            simple drag-and-drop tool in the HR
                                            Admin Dashboard
                                        </li>
                                        <li className="mb-5">
                                            Unified Health Dashboard for
                                            employees accessible via mobile and
                                            web platform
                                        </li>
                                        <li className="mb-5">
                                            Extensively Curated Wellness Library
                                            for Employees
                                        </li>
                                        <li className="mb-5">
                                            Catalogue of offerings across
                                            Physical, Mental, and Financial
                                            well-being
                                        </li>
                                        <li className="mb-5">
                                            HR Admin Dashboard for tracking
                                            engagement and reports
                                        </li>
                                    </ul>
                                    <br />
                                    <br />
                                    <br />
                                    <a
                                        href="/request-demo/"
                                        className="vfitcompanycta py-3"
                                    >
                                        Get Started for Free
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 prem-col">
                            <div className="card mb-5 mb-lg-0 rounded-lg shadow">
                                <div className="card-header premium-header">
                                    <h2 className="card-title">Premium</h2>
                                    <h3 className="">$1</h3>
                                    <p>$1 per user per week</p>
                                </div>
                                <div className="card-body  bg-light rounded-bottom">
                                    <p>
                                        Includes everything in{" "}
                                        <span className="text-red">Basic</span>,
                                        plus:
                                    </p>
                                    <ul className="pricing-ticks mainbullets">
                                        <li className="mb-5">
                                            Unlimited Users
                                        </li>
                                        <li className="mb-5">
                                            Gamified incentivization, badges and
                                            certificates
                                        </li>
                                        <li className="mb-5">
                                            Actionable Insights and Analytics
                                            through HR Admin Dashboard
                                        </li>
                                        <li className="mb-5">
                                            Create inter-department customizable
                                            challenges for remote or hybrid
                                            workforces
                                        </li>
                                        <li className="mb-5">
                                            Best in class customer support
                                        </li>
                                        <li className="mb-5">
                                            Customizable Incentives and Wellness
                                            Rewards
                                        </li>
                                    </ul>
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <a
                                        href="/request-demo/"
                                        className="vfitcompanycta py-3"
                                        style={{ marginTop: 2 }}
                                    >
                                        Request Demo
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="card mb-5 mb-lg-0 rounded-lg shadow">
                                <div className="card-header enterprise-header">
                                    <h2 className="card-title">Enterprise</h2>
                                    <h3 className="">Custom Pricing</h3>
                                    <p>&nbsp;</p>
                                </div>
                                <div className="card-body bg-light rounded-bottom">
                                    <p>
                                        Includes everything in{" "}
                                        <span className="text-red">
                                            Premium
                                        </span>
                                        , plus:
                                    </p>
                                    <ul className="pricing-ticks mainbullets">
                                        <li className="mb-5">
                                            SSO Login and HRMS integrations
                                        </li>
                                        <li className="mb-5">
                                            Challenge activation with Launch
                                            videos and nudges
                                        </li>
                                        <li className="mb-5">
                                            Customized challenge launch social
                                            media post
                                        </li>
                                        <li className="mb-5">
                                            On demand integration with EAP
                                            providers, wellness partners, and
                                            vendors
                                        </li>
                                        <li className="mb-5">
                                            Dedicated account manager to design
                                            and administer challenges
                                        </li>
                                        <li className="mb-5">
                                            On demand wellness events- Yoga,
                                            Habit building, etc.
                                        </li>
                                        <li className="mb-5">
                                            On demand webinars
                                        </li>
                                    </ul>
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />

                                    <a
                                        href="/request-demo/"
                                        className="vfitcompanycta py-3"
                                    >
                                        Let's Talk
                                    </a>
                                </div>
                            </div>
                        </div>
                        <p className="col-12 mt-2 mb-0" style={{ fontSize: 12 }}>
                            <span style={{ color: "red" }}>* </span> Minimum
                            billing $100 for Premium and Enterprise Packages
                        </p>
                        <p className="col-12  " style={{ fontSize: 12 }}>
                            <span style={{ color: "red" }}>* </span>Nominal one
                            time setup fee
                        </p>
                    </div>
                </div>
            </section>
            <section className="section-pdn gray-gradient-bg faqmtop">
                <div className="container custom_container">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center ">
                        <div className="sprite faqpricing featuressprite hidden-xs hidden-sm"></div>
                    </div>
                    <h2 className="section-heading text-center mb-5">
                        Frequently Asked Questions
                    </h2>
                    <div className="col-12 col-md-9 row mb-5">
                        <div id="accordion" className="">
                            <Card>
                                <Button id="faq2">
                                    What kind of fitness trackers are supported
                                    by Vantage Fit?
                                </Button>
                                <UncontrolledCollapse toggler="#faq2">
                                    <CardBody>
                                        Vantage Fit supports almost all the
                                        wearables available in the industry via
                                        Integrating with Google Fit / Apple
                                        Health and correspondingly Fitbit,
                                        Garmin, Xiaomi Bands, Amazefit bands,
                                        Apple Watch and more.
                                    </CardBody>
                                </UncontrolledCollapse>
                            </Card>
                            <Card>
                                <Button id="faq3">
                                    Can people from various countries and
                                    timezones participate in the challenge?
                                </Button>
                                <UncontrolledCollapse toggler="#faq3">
                                    <CardBody>
                                        Yes, we support global challenges with
                                        multiple timezones and multiple
                                        currencies for redemption of prizes.
                                    </CardBody>
                                </UncontrolledCollapse>
                            </Card>
                            <Card>
                                <Button id="faq4">
                                    I have a large workforce but i want to
                                    implement this only for a group of people.
                                    Is that supported?
                                </Button>
                                <UncontrolledCollapse toggler="#faq4">
                                    <CardBody>
                                        Yes, There are three ways to achieve
                                        this. You can either only enable
                                        registration for a selected group of
                                        people,or you can create a challenge
                                        which is applicable only to a selected
                                        Business Unit or Location or even Gender
                                        or a combination of these, For Example,
                                        If you wish to have a challenge for the
                                        Australian Girls Cycling Team, you can
                                        and finally, you can create a private
                                        challenge and send an invite link to
                                        only those people who you want to join.
                                    </CardBody>
                                </UncontrolledCollapse>
                            </Card>
                            <Card>
                                <Button id="faq5">
                                    What options do we have for reporting and
                                    analytics?
                                </Button>
                                <UncontrolledCollapse toggler="#faq5">
                                    <CardBody>
                                        In the Admin Dashboard that you will be
                                        provided, you can view Insights,
                                        summaries, analytics and reports on an
                                        organisational level and on a challenge
                                        level too. You can also manage
                                        challenges, teams and broadcast health
                                        tips from the same Admin Dashboard.
                                    </CardBody>
                                </UncontrolledCollapse>
                            </Card>
                            <Card>
                                <Button id="faq6">
                                    Can we organize webinars on stress
                                    management, time management or other
                                    employee wellness areas with the help of
                                    Vantage Fit
                                </Button>
                                <UncontrolledCollapse toggler="#faq6">
                                    <CardBody>
                                        Yes, we have a dedicated partner network
                                        of wellness vendors and we can organize
                                        webinars with experts. However, this is
                                        an on demand feature and comes under the
                                        Enterprise Plan.
                                    </CardBody>
                                </UncontrolledCollapse>
                            </Card>
                            <Card>
                                <Button id="faq7">
                                    Are integrations possible with HRMS?
                                </Button>
                                <UncontrolledCollapse toggler="#faq7">
                                    <CardBody>Yes.</CardBody>
                                </UncontrolledCollapse>
                            </Card>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default PricingPage;
